module.exports = __webpack_public_path__ + "img/frame-5.2198da8a.png";